import get from 'lodash/get';
import numeral from 'numeral';
import { formatString } from '@server/lib/date-format';
import { getFormattedPhoneNumber } from '@server/lib/phone-format';
import delayTouch from '@client/utils/delay-touch';

const currencyFilter = (value) => numeral(value).format('$0,0.00');

export default {
  touchMap: new WeakMap(),
  filters: {
    localTime: function (value) {
      return formatString(value);
    },
    currency: currencyFilter,
    usDateFormat: function (value) {
      return value ? formatString(value, 'MM/dd/yyyy') : value;
    },
    phoneNumber: function (value) {
      return getFormattedPhoneNumber(value, 'INTERNATIONAL');
    }
  },
  methods: {
    notifyPositive(message) {
      this.$q.notify({
        type: 'positive',
        message,
        position: 'top'
      });
    },

    notifyNegative(message) {
      this.$q.notify({
        type: 'negative',
        message,
        position: 'top'
      });
    },

    notifyWarning(message) {
      this.$q.notify({
        type: 'warning',
        message,
        position: 'top'
      });
    },

    notifyInfo(message) {
      this.$q.notify({
        type: 'info',
        message,
        position: 'top'
      });
    },

    validate(fields) {
      let validationFailure = false;

      fields.forEach((field) => {
        const $field = get(this.$v, field);
        if ($field.$invalid) {
          $field.$touch();
          validationFailure = true;
        }
      });

      if (validationFailure) {
        this.notifyNegative('Form has some invalid fields');
        throw new Error('Invalid form');
      }
    },
    rrIsInvalid(fields) {
      return fields.find((field) => get(this.$v, field).$invalid) || false;
    },

    reset(fields) {
      fields.forEach((field) => {
        const $field = get(this.$v, field);
        if ($field.$invalid) {
          $field.$reset();
        }
      });
    },

    rRGetqSelectBrand(type) {
      let style = {};
      if (type === 'style1') {
        style = {
          labelColor: 'white',
          bgColor: 'primary',
          filled: true,
          inputStyle: {
            color: '#fff'
          },
          class: 'rr-q-select-style-1'
        };
      }
      return style;
    },

    getPercentage(val, total) {
      return (total ? `${Math.round((val / total) * 100 * 100) / 100}%` : 'NA');
    },

    currencyFilter,

    delayTouch
  }
};
